export default __webpack_public_path__ + "static/media/3.b24a44f0.png";